/**
 * True when a thrown error OR an Apollo FetchResult indicates the anonymous
 * download gate was hit. Apollo's `errorPolicy: "all"` resolves mutations
 * with `{ data, errors }` rather than throwing, so we inspect both shapes.
 */
const hasGateMessage = (e: any): boolean =>
  !!e?.message?.includes("DOWNLOAD_LIMIT_REACHED");

export const isDownloadLimitError = (errOrResult: any): boolean => {
  if (!errOrResult) return false;
  if (hasGateMessage(errOrResult)) return true;
  const errors = errOrResult.errors || errOrResult.graphQLErrors;
  return Array.isArray(errors) && errors.some(hasGateMessage);
};
